import React, { useEffect, useState } from 'react';
import { SearchIconGray } from 'components/Icons';
import API from '../../../API';
import { useHistory } from 'react-router-dom';
import { SEARCH_SUPPORT } from '../../../constants/routes';
import NotifyModal from '../../../components/NotifyModal';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const HelpSupportInner = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const [feedback, setFeedback] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const helpful = state => {
    return API.post(`faq/${props.location.state.id}/review`, { is_helpful: state })
      .then(resp => {
        setFeedback(true);
      })
      .catch(err => {});
  };
  const handleSearch = query => {
    if (searchValue === '') {
      return;
    } else {
      query = searchValue;
      return API.post('faq/search', { query })
        .then(resp => {
          resp.push(query);

          history.push({ pathname: SEARCH_SUPPORT, state: resp });
        })
        .catch(err => {});
    }
  };
  return (
    <div className="text-style help-inner-page-wrapper col-12 col-md-6">
      <div style={{ width: '100%', marginBottom: '28px' }} className="support-search-header">
        <input
          onKeyDown={evt => {
            if (evt.key === 'Enter') {
              handleSearch(evt.target.value);
            }
          }}
          onChange={evt => setSearchValue(evt.target.value)}
          type="text"
          value={searchValue}
          placeholder="Find answers"
        />
        <button
          className="search-btn"
          onClick={evt => {
            handleSearch(evt.target.value);
          }}
        >
          <SearchIconGray />
        </button>
      </div>

      <h3>{props.location.state.category.title}</h3>

      <div>
        <p className="text-style help-inner-page-wrapper--title">{props.location.state.title}</p>
        <p className="text-style help-inner-page-wrapper--content">{props.location.state.body}</p>
      </div>
      <hr />
      <div className="inner-page-footer">
        <p>Was this helpful?</p>
        {!feedback ? (
          <div className="inner-page-footer-wrapper">
            <button onClick={() => helpful(0)}>Not helpful</button>
            <button onClick={() => helpful(1)}>Helpful</button>
          </div>
        ) : (
          <p className="help-inner-wrapper-feedback">Thank you for providing feedback!</p>
        )}
      </div>
    </div>
  );
};

export default HelpSupportInner;
